import { QueryClient } from '@tanstack/react-query';

export function createSessionQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5,
        gcTime: 1000 * 60 * 30,
        retry: 3,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: false,
      },
    },
  });
}

let epoch = 0;
let identity = '0:';
let client = createSessionQueryClient();
const listeners = new Set<() => void>();

export function sessionIdentity(
  isAuthenticated: boolean,
  userId?: string | null,
  organizationId?: string | null,
): string {
  return `${isAuthenticated ? '1' : '0'}:${userId ?? ''}:${organizationId ?? ''}`;
}

export function getSessionCacheEpoch(): number {
  return epoch;
}

export function getSessionQueryClient(): QueryClient {
  return client;
}

export function subscribeSessionCache(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => {
    listeners.delete(onChange);
  };
}

export function bindSessionWrites(): (write: () => void) => void {
  const captured = epoch;
  return (write) => {
    if (epoch === captured) write();
  };
}

export function resetSessionCaches(): void {
  epoch += 1;
  const previous = client;
  client = createSessionQueryClient();
  listeners.forEach((listener) => listener());
  void previous.cancelQueries();
  previous.getMutationCache().clear();
  previous.clear();
}

export function syncSessionCacheIdentity(nextIdentity: string): void {
  if (identity === nextIdentity) return;
  identity = nextIdentity;
  resetSessionCaches();
}
